module.exports = __webpack_public_path__ + "img/fawry.1d0c3f70.png";